import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import VisibilitySensor from "react-visibility-sensor";
import { getVisibleSensorAnimation } from "../assets/js/utils";
import useParagraphParserAnimation from "./hooks/useParagraphParserAnimation";
import useWindowSize from "./hooks/useWindowSize";
import ParagraphBlurWords from "./ParagraphBlurWords";

const generalDelay = 0.7;
function SimpleBanner({ title, text, rightAnimation }) {
  const [isVisible, setIsVisible] = useState(false);

  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const windowWidth = useWindowSize();
  // const paragraphRef = useRef();
  // useParagraphParserAnimation(
  //   paragraphRef,
  //   text,
  //   isVisible,
  //   "paragraph-word-animation"
  // );

  const handleVisibilityChange = (visible) => {
    setIsVisible(visible);
  };
  return (
    <VisibilitySensor partialVisibility onChange={handleVisibilityChange}>
      <article
        className="simple-banner"
        style={getVisibleSensorAnimation(
          isVisible,
          `${
            rightAnimation
              ? generalSettings.rtlLanguage
                ? "width-increase-right-side-flipped"
                : "width-increase-right-side"
              : generalSettings.rtlLanguage
              ? "width-increase-flipped"
              : "width-increase"
          } 1s`
        )}
      >
        <h2
          className="simple-banner__title"
          style={getVisibleSensorAnimation(
            isVisible,
            `fadeIn 1s ${generalDelay}s backwards`
          )}
        >
          {title}
        </h2>
        {text.map((paragraph, index) => (
          <VisibilitySensor partialVisibility>
            {({ isVisible }) => (
              <div
                style={getVisibleSensorAnimation(
                  isVisible,
                  `fadeIn 1s ${
                    windowWidth > 767
                      ? 0.5 * index + generalDelay
                      : generalDelay + 0.15 * index
                  }s backwards`
                )}
                className="simple-banner__text"
              >
                {/* <ParagraphBlurWords
              isVisible={isVisible}
              text={paragraph}
              key={index}
            /> */}
                <p key={index} className="simple-banner__text">
                  {paragraph}
                </p>
              </div>
            )}
          </VisibilitySensor>
        ))}
        {/* <p ref={paragraphRef}>{}</p> */}
      </article>
    </VisibilitySensor>
  );
}

export default SimpleBanner;
